import url from './url';



export default url(({ scheduleId = ':scheduleId' }) => `/push-notifications/schedule/${scheduleId}`);
